import React from 'react';
import LoaderStore from 'lib/stores/loaderStore';
import Button from 'lib/components/Button';

const SubmitButton = ({
  onClick,
  formId,
  trackingContext,
  className,
  disabled,
  testid,
  icon,
  loaderId,
  label = 'Submit',
}) => {
  const { status, subjectId, message } = LoaderStore.useState(state => state);
  const pending = (status === 'pending');
  const submitting = loaderId ? ((loaderId === subjectId) && pending) : pending;

  const trackingId = [
    (trackingContext || 'nocontext'),
    (formId ? 'submit' : 'button'),
    (status || 'nostatus'),
    (disabled ? 'disabled' : 'enabled'),
  ].join('-');

  return (
    <Button
      kind={formId ? 'submit' : 'button'}
      id={trackingId}
      className={className || 'mt-3'}
      testid={testid || 'next'}
      disabled={disabled || (submitting || pending)}
      onClick={formId ? undefined : onClick}
      form={formId}
      icon={submitting ? undefined : icon}
      label={
        submitting ? (
          <>
            <span className="me-1">
              {message || 'Submitting'}
              ...
            </span>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          </>
        ) : (
          label
        )
      }
    />
  );
};

export default SubmitButton;
